import React from "react";
import ThemeTopLayout from "gatsby-theme-material-ui-top-layout/src/components/top-layout";
import { Box, createTheme, responsiveFontSizes } from "@mui/material";
import { blue, green, grey } from "@mui/material/colors";
import { Footer } from "../../components/Footer";
import { DonatePopup } from "../../components/DonationPopup";
import { LocationProvider } from "../../components/LocationProvider";
import { DomainProvider, useDomain } from "./../../components/DomainContext";

const domainThemeMap = [
  {
    domains: ["http://localhost:8000", "https://vestimak.mk"],
    theme: responsiveFontSizes(
      createTheme({
        palette: {
          mode: "light",
          primary: {
            main: "#d7210a",
          },
          background: {
            default: grey[200],
          },
        },
        shape: { borderRadius: 8 },
      })
    ),
    hasFooter: true,
    hasDonate: true,
  },
  {
    domains: ["http://localhost:8001", "https://vestimk.mk"],
    theme: responsiveFontSizes(
      createTheme({
        palette: {
          mode: "light",
          primary: {
            main: green[600],
          },
          background: {
            default: grey[200],
          },
        },

        typography: {
          fontFamily: ["Lora"].join(","),
        },
        shape: {
          borderRadius: 10,
        },
      })
    ),
  },
  {
    domains: ["http://localhost:8002", "https://utre.mk"],
    theme: responsiveFontSizes(
      createTheme({
        palette: {
          mode: "light",
          primary: {
            main: blue[700],
          },
          background: {
            default: grey[200],
          },
        },

        typography: {
          fontFamily: ["Ubuntu Mono"].join(","),
        },
        shape: {
          borderRadius: 5,
        },
      })
    ),
  },
  {
    domains: ["http://localhost:8003", "https://24mk.mk"],
    theme: responsiveFontSizes(
      createTheme({
        palette: {
          mode: "dark",
          secondary: {
            main: "#bd362c",
          },
          primary: { main: "#f2e959" },
        },

        typography: {
          fontFamily: ["Ubuntu Mono"].join(","),
        },
        shape: {
          borderRadius: 5,
        },
      })
    ),
  },
  {
    domains: ["http://localhost:8004", "https://mk24.mk"],
    theme: responsiveFontSizes(
      createTheme({
        palette: {
          primary: {
            main: "#FFFF",
          },
        },
        typography: {
          fontFamily: ["Source Sans 3"].join(","),
        },
        shape: {
          borderRadius: 5,
        },
        components: {},
      })
    ),
  },
];

function InnerTopLayout({ children }: { children: React.ReactNode }) {
  const domain = useDomain();
  return (
    <>
      {domainThemeMap.map(({ domains, theme, hasFooter, hasDonate }) => (
        <Box
          key={domains.join("-")}
          sx={{ display: domains.includes(domain) ? "block" : "none" }}
        >
          <ThemeTopLayout theme={theme}>
            {children}
            {hasFooter && <Footer />}
            {hasDonate && <DonatePopup />}
          </ThemeTopLayout>
        </Box>
      ))}
    </>
  );
}

export default function TopLayout({ children }: { children: React.ReactNode }) {
  return (
    <LocationProvider>
      <DomainProvider>
        <InnerTopLayout>{children}</InnerTopLayout>
      </DomainProvider>
    </LocationProvider>
  );
}
